<script>
import {jsPlumb} from 'jsplumb';

import {mapMutations} from 'vuex';

export default {
    name: 'canvas-area-drag-and-drop-wrapper',
    created() {
        const vm = this;

        const el = vm.$el;

        jsPlumb.ready(() => {
            const jsPlumbInstance = jsPlumb.getInstance();

            jsPlumbInstance.setContainer(el);

            const _batch = jsPlumbInstance.batch;

            let _timer = undefined;

            //Delay the repaint associated with batch for our 'initial' render cycle
            //for large journeys we may trigger hundreds of repaints in an extremely short timespan
            //this may freeze the UI for up to a minute
            jsPlumbInstance.batch = function(fn){
                _batch.call(jsPlumbInstance, fn, true);

                clearTimeout(_timer);
                _timer = setTimeout(function(){
                    vm.$store.commit('journeyBuilder/composer/markInitialRenderCycleFinished');
                    jsPlumbInstance.repaintEverything();
                    
                    //Reset jsplumb 'batch', all operations after the initial render cycle are expected
                    //to only be invoked on a small number of components
                    jsPlumbInstance.batch = _batch;
                }, 0);
            }
            
            vm.jsPlumbInstance = jsPlumbInstance;
            vm.isReady = true;
        });
    },
    render(createElement, context) {
        const vm = this;

        //Render nothing until our instance becomes ready
        if(!vm.isReady){
            return createElement('template');
        }

        return vm.$scopedSlots.default({
            jsPlumbInstance: vm.jsPlumbInstance
        });
    },
    data: () => ({
        isReady: false,
        jsPlumbInstance: null
    })
}
</script>